import {
  USE_CASE,
  USER_ROLE,
} from '@trustero/trustero-api-web/lib/account/account_pb'
import {
  getCookieValue,
  setCookieIfExists,
  removeCookieIfExists,
} from 'src/Utils/globalHelpers'

export enum LoginProviders {
  GOOGLE = 'Google',
  AUTH0 = 'Auth0', //Auth0 was acquired by Okta
  OKTA = 'Okta',
  ONELOGIN = 'OneLogin',
  MICROSOFT = 'Microsoft',
  ENTRA = 'Entra',
  PINGONE = 'PingOne',
  ENTRAIDSSO = 'Enterprise SSO',
  ACCESS_LINK = 'Access Link',
}

export type AuthorizationComponentProps = {
  login: ({
    accessToken,
    accountId,
    email,
    useCase,
  }: {
    accessToken: string
    accountId?: string
    email?: string
    redirectUrl: string
    useCase: USE_CASE
    role: USER_ROLE
  }) => void
  setErrorMsg?: React.Dispatch<React.SetStateAction<string>>
  setIsRedirecting?: React.Dispatch<React.SetStateAction<boolean>>
}

const LAST_LOGIN_COOKIE = 'lastlogin'

export const getLastLogin = (): LoginProviders | null => {
  const stored = getCookieValue(LAST_LOGIN_COOKIE)
  if (stored === undefined) {
    return null
  }
  // getCookieValue reads document.cookie's raw (still percent-encoded) value,
  // but js-cookie (setCookieIfExists) percent-encodes on write -- values with
  // reserved characters (e.g. "Access Link") never match the enum unless
  // decoded first.
  let decoded: string
  try {
    decoded = decodeURIComponent(stored)
  } catch {
    decoded = stored
  }
  const validProviders = Object.values(LoginProviders)
  if (validProviders.includes(decoded as LoginProviders)) {
    return decoded as LoginProviders
  }
  return null
}

export const setLastLogin = (lastLogin: LoginProviders): void => {
  setCookieIfExists(LAST_LOGIN_COOKIE, lastLogin)
}

export const clearLastLogin = (): void => {
  removeCookieIfExists(LAST_LOGIN_COOKIE)
}
